import api from './api'

/**
 * Coach Service
 * Handles all coach-related API calls
 */
class CoachService {
  /**
   * Get all coaches for a club
   * GET v1/{club}/coaches
   */
  async getCoaches(clubUuid: string, perPage: number = 9999, page: number = 1): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/coaches`, {
      params: {
        per_page: perPage,
        page: page
      }
    })
    return response.data
  }

  /**
   * Get single coach
   * GET v1/{club}/coaches/{coach}
   */
  async getCoach(clubUuid: string, coachUuid: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/coaches/${coachUuid}`)
    return response.data
  }

  /**
   * Create new coach
   * POST v1/{club}/coaches
   */
  async createCoach(clubUuid: string, formData: FormData): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/coaches`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  /**
   * Update coach
   * PUT v1/{club}/coaches/{coach}
   */
  async updateCoach(clubUuid: string, coachUuid: string, formData: FormData): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/coaches/${coachUuid}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: {
        _method: 'PUT'
      }
    })
    return response.data
  }

  /**
   * Delete coach
   * DELETE v1/{club}/coaches/{coach}
   */
  async deleteCoach(clubUuid: string, coachUuid: string): Promise<any> {
    const response = await api.delete(`v1/${clubUuid}/coaches/${coachUuid}`)
    return response.data
  }

  /**
   * Get recent attendance for coach with pagination
   * GET v1/{club}/coaches/{coach}/recent-attendance
   */
  async getRecentAttendance(clubUuid: string, coachUuid: string, perPage: number = 25, page: number = 1): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/coaches/${coachUuid}/recent-attendance`, {
      params: {
        per_page: perPage,
        page: page
      }
    })
    return response.data
  }

  /**
   * Get monthly attendance stats for coach
   * GET v1/{club}/coaches/{coach}/attendance-stats
   */
  async getAttendanceStats(clubUuid: string, coachUuid: string, date: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/coaches/${coachUuid}/attendance-stats`, {
      params: { date }
    })
    return response.data
  }

  /**
   * Resend invitation to coach
   * POST v1/{club}/coaches/{coach}/resend-invitation
   */
  async resendInvitation(clubUuid: string, coachUuid: string): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/coaches/${coachUuid}/resend-invitation`)
    return response.data
  }
}

export default new CoachService()
